<template>
	<div class="icg-calc-spinner">
		<div class="double-bounce1"></div>
		<div class="double-bounce2"></div>
	</div>
</template>

<script>
export default {};
</script>
